export const FETCH_CLIENTES_REQUEST = "FETCH_CLIENTES_REQUEST";
export const FETCH_CLIENTES_SUCCESS = "FETCH_CLIENTES_SUCCESS";
export const FETCH_CLIENTES_FAILURE = "FETCH_CLIENTES_FAILURE";
